import React from 'react';
import './Footer.css';
import { FaEnvelope, FaLinkedin } from 'react-icons/fa'; 

const Footer = () => {
  return (
    <footer className="footer" id="contact">
      
      {/* Avlång bar */}
      <div className="footer-band">

        <div className="footer-content">

          <h1 className="footer-heading">Let's Connect</h1>
          <p className="footer-subheading">
            Feel free to reach out anytime.
          </p>

          <div className="footer-links">
            <a 
              href="mailto:wilma.edman@gmail.com"
              className="footer-link"
            >
              <FaEnvelope className="icon" />
              wilma.edman@gmail.com
            </a>

            <a 
              href="https://www.linkedin.com/in/wilma-edman-86ba47184/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              <FaLinkedin className="icon" />
              LinkedIn
            </a>
          </div>

        </div>

      </div>

    </footer>
  );
};

export default Footer;

